module.exports = __webpack_public_path__ + "img/honor-right-1-6.cfbf8c88.jpg";